// NotFound.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import { useSelector } from "react-redux";

const NotFound = () => {
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
  };

  const headingStyle = {
    marginBottom: "16px",
    fontSize: "2rem",
  };

  const textStyle = {
    fontSize: "1rem",
  };

  const buttonStyle = {
    marginTop: "16px",
    padding: "10px 20px",
    backgroundColor: "#1976D2",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "4px",
    fontSize: "1rem",
    cursor: "pointer",
  };

  const [isUserData, setIsUserData] = useState(false);

  useEffect(() => {
    setIsUserData(sessionStorage.getItem("userData") ? true : false);
  }, []);

  const userData = useSelector((state) => state.loginReducer.updatedState);
  return (
    <div style={containerStyle}>
        {isUserData&&<Navbar/>}
      <h1 style={headingStyle}>404 - Not Found</h1>
      <p style={textStyle}>
        Oops! The page you are looking for might be in another castle.
      </p>
      <Link to="/" style={buttonStyle}>
        Go Home
      </Link>
    </div>
  );
};

export default NotFound;
